export const avancementKeys = {
  all: ["avancement"] as const,
  details: () => [...avancementKeys.all, "detail"],
  detail: (siren: string, millesime: number) => [
    ...avancementKeys.details(),
    siren,
    millesime,
  ],
};
